import { customerSearchColumns, groupColumns, nhomColumns, QUERY_KEYS, regionColumns } from '@/constants';
import { FormFieldV2, SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { Group, KhachHang, KhuVuc } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface DetailsTabProps {
  searchFieldStates: {
    customer: KhachHang | null;
    setCustomer: (customer: KhachHang | null) => void;
    customerGroup1: Group | null;
    setCustomerGroup1: (group: Group | null) => void;
    customerGroup2: Group | null;
    setCustomerGroup2: (group: Group | null) => void;
    customerGroup3: Group | null;
    setCustomerGroup3: (group: Group | null) => void;
    region: KhuVuc | null;
    setRegion: (region: KhuVuc | null) => void;
  };
}

const DetailsTab: React.FC<DetailsTabProps> = ({ searchFieldStates }) => {
  return (
    <div className='w-[800px] min-w-[800px] space-y-2 p-4'>
      <div className='flex flex-col space-y-1'>
        <div className='flex items-center gap-1'>
          <Label className='w-40 min-w-40'>Mã khách hàng:</Label>
          <SearchField<KhachHang>
            displayRelatedField={`customer_name`}
            columnDisplay={`customer_code`}
            searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}`}
            searchColumns={customerSearchColumns}
            value={searchFieldStates.customer?.customer_code || ''}
            relatedFieldValue={searchFieldStates.customer?.customer_name || ''}
            onRowSelection={searchFieldStates.setCustomer}
          />
        </div>

        <div className='flex items-center pt-1'>
          <Label className='w-40 min-w-40'>Nhóm khách hàng:</Label>
          <div className=''>
            <div className='flex gap-1'>
              <div className=''>
                <SearchField<Group>
                  searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=NCC1`}
                  searchColumns={nhomColumns}
                  value={searchFieldStates.customerGroup2?.ma_nhom || ''}
                  onRowSelection={searchFieldStates.setCustomerGroup2}
                />
              </div>
              <div className=''>
                <SearchField<Group>
                  searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=NCC2`}
                  searchColumns={nhomColumns}
                  value={searchFieldStates.customerGroup2?.ma_nhom || ''}
                  onRowSelection={searchFieldStates.setCustomerGroup2}
                />
              </div>
              <div className=''>
                <SearchField<Group>
                  searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=NCC3`}
                  searchColumns={nhomColumns}
                  value={searchFieldStates.customerGroup3?.ten_phan_nhom || ''}
                  onRowSelection={searchFieldStates.setCustomerGroup3}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='mb-4'>
          <div className='flex items-center'>
            <Label className='w-40 min-w-40'>Khu vực:</Label>
            <SearchField<KhuVuc>
              type='text'
              displayRelatedField={`rgname`}
              columnDisplay={`rg_code`}
              searchEndpoint={`/${QUERY_KEYS.KHU_VUC}`}
              searchColumns={regionColumns}
              value={searchFieldStates.region?.rg_code || ''}
              relatedFieldValue={searchFieldStates.region?.rgname || ''}
              onRowSelection={searchFieldStates.setRegion}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <FormFieldV2
            name='tat_toan'
            label='Tất toán'
            labelClassName='w-40'
            type='select'
            options={[
              { value: '0', label: 'Chưa tất toán' },
              { value: '1', label: 'Đã tất toán sử dụng tính năng này' }
            ]}
            className='w-[400px]'
          />
        </div>
        <div className='flex items-center'>
          <FormFieldV2
            name='mau_bao_cao'
            label='Mẫu báo cáo'
            labelClassName='w-40'
            type='select'
            options={[
              { value: '0', label: 'Mẫu tiền chuẩn' },
              { value: '1', label: 'Mẫu ngoại tệ' }
            ]}
            className='w-[400px]'
          />
        </div>
      </div>
    </div>
  );
};

export default DetailsTab;
